import { Control, Controller, useController } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'

import { FormData } from '../../ChallengeAdmin'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { GoalWithProgress } from '../../../../services/api.types'
import { getPeriodWithDays } from '../../../ChallengeInfo/ChallengeInfo'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  name: any
  onChallengeChange: any
  fields: any[]
  index: number
  relevantChallenges: GoalWithProgress[]
}

export default function ChallengeTotalPointsChallengeField(props: ChallengePointsUnitFieldProps) {
  const { control, name, onChallengeChange, fields, index, relevantChallenges } = props
  const {
    field: { onChange, name: controllerName, value, ref },
  } = useController({
    control,
    name,
  })

  const handleChange = (...event: any[]) => {
    onChange(...event)
    onChallengeChange(index, ...event)
  }

  const [period, setPeriod] = React.useState('')
  React.useEffect(() => {
    const challenge = relevantChallenges.find((g) => g.id === value)
    if (challenge) setPeriod(getPeriodWithDays(challenge))
  }, [value])

  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumSelect
          label={period}
          /*StartIconComponent={
            <YumActivityIcon category={CustomTypeCategory.POINTS} color={'darkBlue'} isInactive={true} />
          }*/
          inputRef={ref}
          {...otherField}
          style={{ marginBottom: '12px' }}
          onChange={handleChange}
        >
          {relevantChallenges.map((challenge, keyIndex) => (
            <option
              key={keyIndex}
              value={challenge.id}
              disabled={fields.some((f) => f.id === challenge.id && f.id !== otherField.value)}
            >
              {challenge.title}
            </option>
          ))}
        </YumSelect>
      )}
    />
  )
}
